// extracted by mini-css-extract-plugin
module.exports = {"container":"Notes_container__IGuVA","newLabel":"Notes_newLabel__mLbXd","newLabelContainer":"Notes_newLabelContainer__kHpCe"};